// extracted by mini-css-extract-plugin
module.exports = {"poizon-book-list":"poizon-book-list___1zmUE"};